import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuthState } from '../hooks/useAuth';
import { Spinner } from './ui/Spinner';

export function AuthGate() {
  const { user, loading } = useAuthState();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
